import React from 'react';
import MainNav from "../Common/MainNav.js";
import AddOns from "./Components/AddOns.js";
import EssentialsTab from "./Components/EssentialsTab";
import APIProgram from './Components/APIProgram.js';
import Hero from './Components/Hero';
import ExploreLegal from './Components/ExploreLegal';
import { buttonLabels } from '../../Constants/Data';

const Explore = ({ page }) => {
    return (
        <div className="w-full flex flex-col">
            <MainNav navbarColor={"#26051C"} />

            <div
                className="w-full h-fit py-[20px] lg:py-[40px] flex flex-col justify-center items-center"
                style={{
                    backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/CharmBackgroundEnlarged.png)`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <h3 className="font-allroundgothic font-[600] text-center text-white text-xl md:text-4xl font-semibold">CharmHealth Marketplace</h3>
                <Hero selectedServices={page} />
            </div>

            <div className="w-full">
                {
                    page === "all" && <AddOns page={'all'} />
                }
                {
                    page === "essentials" && <EssentialsTab />
                }
                {
                    page === "custom" && <APIProgram />
                }
                {buttonLabels
                    .filter(({ urlLabel }) => urlLabel !== "all") // Exclude "all" from map
                    .map(({ urlLabel }) => (
                        page === urlLabel && <AddOns key={urlLabel} page={urlLabel} />
                    ))}

            </div>

            <div className="w-full bg-charmPurple">
                <ExploreLegal />
            </div>
        </div>
    );
}

export default Explore;